import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import ContactCard from './ContactCard';
import { DialogTitleWithClose } from '@/components/common/DialogTitleWithClose';
import { ContactConfig, ContactProps } from '@/models/Contact';

type PendingDuplicateContact = {
  draftContact: ContactProps;
  existingContact: ContactProps;
};

export default function DuplicateContactPromptModal({
  open,
  isLoading,
  pendingDuplicateContact,
  contactConfig,
  onClose,
  onCreateSeparate,
  onUseExisting,
}: {
  open: boolean;
  isLoading: boolean;
  pendingDuplicateContact: PendingDuplicateContact | null;
  contactConfig: ContactConfig;
  onClose: () => void;
  onCreateSeparate: () => Promise<void>;
  onUseExisting: () => Promise<void>;
}) {
  const hasName =
    pendingDuplicateContact?.existingContact?.firstName != null &&
    pendingDuplicateContact?.existingContact?.lastName != null;

  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} maxWidth='sm' fullWidth>
      <DialogTitleWithClose onClose={isLoading ? undefined : onClose}>
        Possible Duplicate Contact
      </DialogTitleWithClose>
      <DialogContent>
        <Typography>
          A contact with the same name and email already exists.
          {hasName ? ' Use ' : ' Use the existing contact instead?'}
          {hasName && (
            <Typography component='span' sx={{ fontWeight: 700 }}>
              {`${pendingDuplicateContact.existingContact.firstName} ${pendingDuplicateContact.existingContact.lastName}`}
            </Typography>
          )}
          {hasName ? ' instead?' : ''}
        </Typography>
        {pendingDuplicateContact?.existingContact != null && (
          <Box marginTop='16px'>
            <ContactCard
              showDuplicateWarning={true}
              contact={pendingDuplicateContact.existingContact}
              contactConfig={contactConfig}
              onEditRequested={() => {}}
              showEditButton={false}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 2 }}>
        <Button variant='secondary' onClick={onCreateSeparate} disabled={isLoading}>
          Create Separate Contact
        </Button>
        <Button variant='primary' onClick={onUseExisting} disabled={isLoading}>
          Use Existing Contact
        </Button>
      </DialogActions>
    </Dialog>
  );
}
